
namespace PaperTrail.NewsletterControl {

    @Serenity.Decorators.registerClass()
    export class StoryContributorDialog extends Serenity.EntityDialog<StoryContributorRow, any> {
        protected getFormKey() { return StoryContributorForm.formKey; }
        protected getIdProperty() { return StoryContributorRow.idProperty; }
        protected getLocalTextPrefix() { return StoryContributorRow.localTextPrefix; }
        protected getNameProperty() { return StoryContributorRow.nameProperty; }
        protected getService() { return StoryService.baseUrl; } 
        protected getDeletePermission() { return StoryContributorRow.deletePermission; }
        protected getInsertPermission() { return StoryContributorRow.insertPermission; }
        protected getUpdatePermission() { return StoryContributorRow.updatePermission; }

        protected form = new StoryContributorForm(this.idPrefix);

        protected onDialogOpen() {
            super.onDialogOpen();

            Q.Router.replace("");

            if (!Q.Authorization.hasPermission("Newsletter:Organizer")) { 
                this.form.UserId.element.hide();
                this.form.UserId.getGridField().hide();
                this.form.UserId.element.toggleClass("required", false);
                this.form.UserId.getGridField().find("label").find("sup").toggle(false);

                this.form.DateModified.element.hide();
                this.form.DateModified.getGridField().hide();
                this.form.DateModified.element.toggleClass("required", false);
                this.form.DateModified.getGridField().find("label").find("sup").toggle(false);

                this.form.DatePublished.element.hide();
                this.form.DatePublished.getGridField().hide();
                this.form.DatePublished.element.toggleClass("required", false);
                this.form.DatePublished.getGridField().find("label").find("sup").toggle(false);
            }
        }

        loadEntity(entity: StoryContributorRow) {
            super.loadEntity(entity);
            if (this.isNewOrDeleted()) { 
                var user = Q.Authorization.userDefinition
                var userId = Administration.UserRow.getLookup().items
                    .filter(x => x.Username === user.Username)[0].UserId;
                this.form.UserId.value = userId.toString();
            }
            else {
                this.form.NewslettersList.values = entity.NewslettersList.map(String);
                var storyContent = entity.StoryBlocks.map(sb => {
                    return sb.Content;
                })
                this.form.StoryText.set_value(storyContent.join(""));
            }
        }
    }
}